var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRssFeedSymbol = function SvgRssFeedSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rss-feed-symbol_svg__a)",
    fill: "#89969A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.765 22.953a3.71 3.71 0 1 0 0-7.419 3.71 3.71 0 0 0 0 7.42ZM12.427 21.136a1.86 1.86 0 0 0 1.855 1.855 1.86 1.86 0 0 0 1.855-1.855c0-7.865-6.4-14.283-14.282-14.283A1.86 1.86 0 0 0 0 8.708a1.86 1.86 0 0 0 1.855 1.855c5.843 0 10.572 4.748 10.572 10.573Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.146 22.991a1.86 1.86 0 0 0 1.855-1.855C23 9.488 13.523.01 1.874.01A1.86 1.86 0 0 0 .02 1.865a1.86 1.86 0 0 0 1.855 1.854c9.608 0 17.417 7.81 17.417 17.417 0 1.02.816 1.855 1.855 1.855Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rss-feed-symbol_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h23v23H0z"
  })))));
};
export default SvgRssFeedSymbol;